import { api } from './index';
const BASE_PATH = '/api/internal/trademark_applications';
export const orderApi = { create(trademarkApplicationId) { const path = `${BASE_PATH}/${trademarkApplicationId}/orders`; return api({ method: 'post', url: path }).then(response => response.data.order); } };
